<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <!-- <span class="app-brand-logo demo bg-primary">
        <img class="w-100" src="https://storage.googleapis.com/intergol/zabkowice/settings/zabkowice.jpg" alt="Zabkowice">
      </span> -->
      <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal ml-2">Portal</router-link>
      <a href="javascript:void(0)" class="layout-sidenav-toggle sidenav-link text-large ml-auto" @click="toggleSidenav()">
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

    <!-- Links -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <!-- DASHBOARD -->
      <sidenav-header class="small font-weight-semibold">DANE</sidenav-header>
      <sidenav-router-link icon="ion ion-ios-speedometer" :active="isMenuActive(`${basePath}/podsumowanie`)" :to="`${basePath}/podsumowanie`" :exact="true">Podsumowanie</sidenav-router-link>

      <!-- STATYSTYKI
      <sidenav-router-link icon="ion ion-md-analytics" :active="isMenuActive(`${basePath}/statystyki`)" :to="`${basePath}/statystyki`" :exact="true">Statystyki</sidenav-router-link>
      -->

      <!-- TREŚĆ -->
      <!-- <sidenav-divider class="mb-1"/> -->
      <sidenav-header class="small font-weight-semibold">TREŚĆ</sidenav-header>

      <sidenav-router-link icon="ion ion-md-quote" :to="`${basePath}/artykuly`" :active="isMenuActive(`${basePath}/artykuly`)" :exact="true" v-if="hasRole(['Articles::FullAccess', 'Articles::List'])">Artykuły</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-construct" :to="`${basePath}/artykuly/ai`" :active="isMenuActive(`${basePath}/artykuly/ai`)" :exact="true" v-if="hasRole(['Newsroom::FullAccess', 'Newsroom::Edit', 'Newsroom::Generate'])">Artykuły AI</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-bookmark" :to="`${basePath}/artykuly/kategorie`" :active="isMenuActive(`${basePath}/artykuly/kategorie`)" :exact="true" v-if="hasRole(['Articles::FullAccess', 'Articles::CategoriesView'])">Kategorie</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-barcode" :to="`${basePath}/komentarze`" :active="isMenuActive(`${basePath}/komentarze`)" :exact="true" v-if="hasRole(['Comments::Access'])">Komentarze</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-document" :to="`${basePath}/podstrony`" :active="isMenuActive(`${basePath}/podstrony`)" :exact="true" v-if="hasRole(['Pages::FullAccess', 'Pages::Access'])">Podstrony</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-paper" :to="`${basePath}/slownik`" :active="isMenuActive(`${basePath}/slownik`)" :exact="true" v-if="hasRole(['Dictionary::FullAccess', 'Dictionary::Access'])">Słownik</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-redo" :to="`${basePath}/przekierowania`" :active="isMenuActive(`${basePath}/przekierowania`)" :exact="true" v-if="hasRole(['Redirects::FullAccess', 'Redirects::Access'])">Przekierowania</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-albums" :to="`${basePath}/materialy-uzytkownikow`" :active="isMenuActive(`${basePath}/materialy-uzytkownikow`)" v-if="hasRole(['UserMaterials::FullAccess', 'UserMaterials::Access'])" :exact="true" >Nadesłane materiały</sidenav-router-link>

      <sidenav-divider class="mb-1" v-if="hasRole(['Newsroom::FullAccess', 'Newsroom::Edit', 'Newsroom::Generate', 'Newsroom::AddSource'])"/>
      <sidenav-header class="small font-weight-semibold" v-if="hasRole(['Newsroom::FullAccess', 'Newsroom::Edit', 'Newsroom::Generate', 'Newsroom::AddSource'])">NEWSROOM</sidenav-header>
      <sidenav-router-link icon="ion ion-md-globe" :to="`${basePath}/newsroom/zrodla`" :active="isMenuActive(`${basePath}/newsroom/zrodla`)" :exact="true" v-if="hasRole(['Newsroom::FullAccess', 'Newsroom::Edit', 'Newsroom::Generate'])">Lista źródeł</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-add-circle-outline" :to="`${basePath}/newsroom/zrodla/dodaj`" :active="isMenuActive(`${basePath}/newsroom/zrodla/dodaj`)" :exact="true" v-if="hasRole(['Newsroom::FullAccess', 'Newsroom::AddSource'])">Dodaj źródło</sidenav-router-link>
      <!-- ukryte tymczasowo (operator widzi ziarna w Artykułach AI z większą wartością) -->
      <sidenav-router-link icon="ion ion-md-list-box" :to="`${basePath}/newsroom/ziarna`" :active="isMenuActive(`${basePath}/newsroom/ziarna`)" :exact="true" v-if="false && hasRole(['Newsroom::FullAccess', 'Newsroom::Edit', 'Newsroom::Generate'])">Lista ziaren</sidenav-router-link>
      <!-- ukryte tymczasowo (auto-trigger przez sync-seeds + per-source settings) -->
      <sidenav-router-link icon="ion ion-md-cog" :to="`${basePath}/newsroom/autogenerowanie`" :active="isMenuActive(`${basePath}/newsroom/autogenerowanie`)" :exact="true" v-if="false && hasRole(['Newsroom::FullAccess', 'Newsroom::Edit'])">Moduł autogenerowania</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-mail" :to="`${basePath}/newsroom/powiadomienia`" :active="isMenuActive(`${basePath}/newsroom/powiadomienia`)" :exact="true" v-if="hasRole(['Newsroom::FullAccess', 'Newsroom::Edit'])">Powiadomienia mailowe</sidenav-router-link>
      <!-- OGŁOSZENIA --
      <!-- <sidenav-divider class="mb-1" v-if="hasRole(['admin', 'redactor'])"/>
      <sidenav-header class="small font-weight-semibold" v-if="hasRole(['admin', 'redactor'])">OGŁOSZENIA</sidenav-header> -->

      <!-- <sidenav-router-link icon="ion ion-md-list-box" :to="`${basePath}/ogloszenia`" :active="isMenuActive(`${basePath}/ogloszenia`)" :exact="true" v-if="hasRole(['admin', 'redactor'])">Ogłoszenia</sidenav-router-link> -->
      <!-- <sidenav-router-link icon="ion ion-md-bookmark" :to="`${basePath}/ogloszenia/kategorie`" :active="isMenuActive(`${basePath}/ogloszenia/kategorie`)" :exact="true" v-if="hasRole(['admin', 'redactor'])">Kategorie</sidenav-router-link> -->

      <!-- WYGLĄD -->
      <sidenav-divider class="mb-1" v-if="hasRole(['Settings::FullAccess', 'Settings::Template'])"/>
      <sidenav-header class="small font-weight-semibold" v-if="hasRole(['Settings::FullAccess', 'Settings::Template'])">WYGLĄD</sidenav-header>

      <sidenav-router-link icon="ion ion-md-options" :to="`${basePath}/wyglad/szablon`" :active="isMenuActive(`${basePath}/wyglad/szablon`)" :exact="true" v-if="hasRole(['Settings::FullAccess', 'Settings::Template'])">Edycja szablonu</sidenav-router-link>
      <!-- <sidenav-router-link icon="ion ion-md-today" :to="`${basePath}/wyglad/widgety`" :active="isMenuActive(`${basePath}/wyglad/widgety`)" :exact="true">Widgety</sidenav-router-link> -->

      <!-- USTAWIENIA -->
      <sidenav-divider class="mb-1" v-if="hasRole(['Settings::FullAccess', 'Settings::Edit'])"/>
      <sidenav-header class="small font-weight-semibold" v-if="hasRole(['Settings::FullAccess', 'Settings::Edit'])">USTAWIENIA</sidenav-header>

      <sidenav-router-link icon="ion ion-md-settings" :to="`${basePath}/ustawienia`" :active="isMenuActive(`${basePath}/ustawienia`)" :exact="true" v-if="hasRole(['Settings::FullAccess', 'Settings::Edit'])">Ustawienia portalu</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-mail" :to="`${basePath}/ustawienia/smtp`" :active="isMenuActive(`${basePath}/ustawienia/smtp`)" :exact="true" v-if="hasRole(['Settings::FullAccess', 'Settings::Edit'])">Ustawienia SMTP</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-grid" v-if="hasRole(['Placements::View'])" :active="isMenuActive(`${basePath}/reklamy`)" :to="`${basePath}/reklamy`" :exact="true">Ustawienia reklamy</sidenav-router-link>

      <sidenav-header class="small font-weight-semibold">Newsletter</sidenav-header>
      <sidenav-router-link icon="ion ion-md-paper" :to="`${basePath}/newsletter`" :active="isMenuActive(`${basePath}/newsletter`)" :exact="true" v-if="hasRole(['Newsletter::Access', 'Newsletter::FullAccess'])">Lista newsletterów</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-bookmark" :to="`${basePath}/newsletter/kategorie`" :active="isMenuActive(`${basePath}/newsletter/kategorie`)" :exact="true" v-if="hasRole(['Newsletter::Access', 'Newsletter::FullAccess'])">Kategorie newsletterów</sidenav-router-link>

      <!-- POWRÓT -->
      <sidenav-router-link icon="ion ion-md-arrow-back" class="mt-auto" :to="`/zarzadca`">Powrót do zarządcy</sidenav-router-link>

    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    },
    basePath: {
      type: String,
      default: ''
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path === url
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },
  }
}
</script>
